(function($) {
    $(() => {
        const slider = $('.counseling-content-slider');

        slider.on('init reInit', function(event, slick) {
            $('.counseling-content-slider__total-count').html(`1/${slick.slideCount}`);
        });

        slider.on('afterChange', function (event, slick, currentSlide) {
            $('.counseling-content-slider__total-count').html(`${currentSlide + 1}/${slick.slideCount}`);

            $('.counseling-content-slider-container').css('background-image', `url("${$('.slick-active .container').data('image')}"`);
        });

        slider.slick(
            {
                infinite: true,
                slidesToShow: 1,
                arrows: true,
                nextArrow:  $('.counseling-content-slider__right'),
                prevArrow:  $('.counseling-content-slider__left'),
            }
        );
    });
})(jQuery);